<template>
    <div class="container">
        <router-view :user="currentUser"></router-view>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    export default {
        name: 'Dashboard',
        computed: {
            ...mapGetters(['currentUser'])
        },
        watch: {
            currentUser (val) {
                if (!val) {
                    this.$router.push('/')
                }
            }
        }
    }
</script>

<style>
    .btn {
        margin-right: 3px;
    }
</style>
